import { render, staticRenderFns } from "./FormKeyword.vue?vue&type=template&id=994f1acc&"
import script from "./FormKeyword.vue?vue&type=script&lang=ts&"
export * from "./FormKeyword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports